console.log(process.env)

export const IS_MAINNET                 = Boolean(process.env.REACT_APP_IS_MAINNET !== 'false');  // If REACT_APP_IS_MAINNET is unset, set it to true by default
export const TESTNET_LAUNCHPAD_NAME     = process.env.REACT_APP_TESTNET_LAUNCHPAD_NAME || 'LUKSO Testnet';
export const EL_TESTNET_NAME            = process.env.REACT_APP_EL_TESTNET_NAME || 'Testnet';

// private vars (or derived from)
export const PORTIS_DAPP_ID             = process.env.REACT_APP_PORTIS_DAPP_ID     || '';
export const INFURA_PROJECT_ID          = process.env.REACT_APP_INFURA_PROJECT_ID  || '';
export const ENABLE_RPC_FEATURES        = Boolean(INFURA_PROJECT_ID && INFURA_PROJECT_ID !== '');
export const INFURA_URL                 = process.env.REACT_APP_RPC_URL ? process.env.REACT_APP_RPC_URL : `https://${IS_MAINNET ? "mainnet" : EL_TESTNET_NAME.toLowerCase()}.infura.io/v3/${INFURA_PROJECT_ID}`;

// public
export const NETWORK_NAME                 = IS_MAINNET ? 'LUKSO Mainnet' : TESTNET_LAUNCHPAD_NAME;
export const TICKER_NAME                  = IS_MAINNET ? 'LYX' : 'LYXt';
export const LYXERSCAN_URL                = process.env.REACT_APP_EXECUTIONEXPLORER_URL || ''
export const BEACONSCAN_URL               = process.env.REACT_APP_CONSENSUSEXPLORER_URL || '' // 'https://beaconscan.com/validator'
export const BEACONCHAIN_URL              = process.env.REACT_APP_CONSENSUSEXPLORER_URL || ''
export const FORTMATIC_KEY                = process.env.REACT_APP_FORTMATIC_KEY       || 'pk_test_D113D979E0D3508F';
export const CONTRACT_ADDRESS             = process.env.REACT_APP_CONTRACT_ADDRESS;
export const DEPOSIT_CONTRACT_LINK        = process.env.REACT_APP_CONTRACT_ADDRESS_LINK || ''
export const COMPOUNDING_CONTRACT_ADDRESS = process.env.REACT_APP_COMPOUNDING_CONTRACT_ADDRESS || '0x0000BBdDc7CE488642fb579F8B00f3a590007251'
export const MIN_DEPOSIT_CLI_VERSION      = process.env.REACT_APP_MIN_DEPOSIT_CLI_VERSION  || '1.6.4';
export const LIGHTHOUSE_INSTALLATION_URL  = process.env.REACT_APP_LIGHTHOUSE_INSTALLATION_URL || 'https://lighthouse-book.sigmaprime.io/';
export const NIMBUS_INSTALLATION_URL      = process.env.REACT_APP_NIMBUS_INSTALLATION_URL  || 'https://nimbus.guide/intro.html';
export const PRYSM_INSTALLATION_URL       = process.env.REACT_APP_PRYSM_INSTALLATION_URL   || 'https://docs.prylabs.network/docs/install/install-with-script';
export const TEKU_INSTALLATION_URL        = process.env.REACT_APP_TEKU_INSTALLATION_URL    || 'https://docs.teku.pegasys.tech/en/latest/HowTo/Get-Started/Build-From-Source/';
export const MAINNET_LAUNCHPAD_URL        = 'https://deposit.lukso.network/'
export const TESTNET_LAUNCHPAD_URL        = `https://deposit.testnet.lukso.network/`
export const FAUCET_URL                   = process.env.REACT_APP_FAUCET_URL || ''
export const TUTORIAL_URL                 = process.env.REACT_APP_TUTORIAL_URL || ''

export const CHAINID                    = Number(process.env.REACT_APP_CHAINID) || 42

if(process.env.REACT_APP_LYX_REQUIREMENT && Number.isNaN(Number(process.env.REACT_APP_LYX_REQUIREMENT))) {
    throw new Error("REACT_APP_LYX_REQUIREMENT must be of type: number")
}
export const LYX_REQUIREMENT            = process.env.REACT_APP_LYX_REQUIREMENT     || 524288; // min required LYX to be staked before merge (16,384 validators)

// LYX_DEPOSIT_OFFSET is added to the balance of the deposit contract to account for testnet deposit-contracts that allow some number of free deposit
if(process.env.REACT_APP_LYX_DEPOSIT_OFFSET && Number.isNaN(Number(process.env.REACT_APP_LYX_DEPOSIT_OFFSET))) {
    throw new Error("REACT_APP_LYX_DEPOSIT_OFFSET must be of type: number")
}
export const LYX_DEPOSIT_OFFSET = Number(process.env.REACT_APP_LYX_DEPOSIT_OFFSET) * Number(!IS_MAINNET) || 0;

let forkVersion = Buffer.from('00000000', 'hex')
if(typeof process.env.REACT_APP_GENESIS_FORK_VERSION === 'string'){
    forkVersion = Buffer.from(process.env.REACT_APP_GENESIS_FORK_VERSION.replace(/0x/g, ''), 'hex');
}
export const GENESIS_FORK_VERSION = forkVersion;

if(process.env.REACT_APP_MIN_ACTIVATION_BALANCE && Number.isNaN(Number(process.env.REACT_APP_MIN_ACTIVATION_BALANCE))) {
    throw new Error("REACT_APP_MIN_ACTIVATION_BALANCE must be of type: number")
}
export const MIN_ACTIVATION_BALANCE     = Number(process.env.REACT_APP_MIN_ACTIVATION_BALANCE) || 32;

if(process.env.REACT_APP_MAX_EFFECTIVE_BALANCE && Number.isNaN(Number(process.env.REACT_APP_MAX_EFFECTIVE_BALANCE))) {
    throw new Error("REACT_APP_MAX_EFFECTIVE_BALANCE must be of type: number")
}
export const MAX_EFFECTIVE_BALANCE      = Number(process.env.REACT_APP_MAX_EFFECTIVE_BALANCE) || 2048;

if(process.env.REACT_APP_PRICE_PER_VALIDATOR && Number.isNaN(Number(process.env.REACT_APP_PRICE_PER_VALIDATOR))) {
    throw new Error("REACT_APP_PRICE_PER_VALIDATOR must be of type: number")
}
export const PRICE_PER_VALIDATOR        = process.env.REACT_APP_PRICE_PER_VALIDATOR || 32;

if(process.env.REACT_APP_EJECTION_PRICE && Number.isNaN(Number(process.env.REACT_APP_EJECTION_PRICE))) {
    throw new Error("REACT_APP_EJECTION_PRICE must be of type: number")
}
export const EJECTION_PRICE             = process.env.REACT_APP_EJECTION_PRICE || 16;

// BLS signature verification variables
export const LYXER_TO_GWEI              = 1e9;
export const MIN_DEPOSIT_AMOUNT         = 1 * LYXER_TO_GWEI;
export const DOMAIN_DEPOSIT             = Buffer.from('03000000', 'hex');
export const EMPTY_ROOT                 = Buffer.from('0000000000000000000000000000000000000000000000000000000000000000', 'hex');
export const EXCESS_INHIBITOR           = "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff";
export const COMPOUNDING_FEE_ADDITION   = Number(process.env.REACT_APP_COMPOUNDING_FEE_ADDITION) || 3;
